import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UsersEditContain from '../../../Component/Proxies/EditProxy';
import { useTranslation } from 'react-i18next';

const UsersEdit = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Proxies")} title={t("Edit Proxy")} />
      <UsersEditContain />
    </Fragment>
  );
};
export default UsersEdit;
